import {EntityDomainModel} from "../../../infrastructure/models/entity/entity.domain-model";
import {MemberApiModel} from "./member-api-model";
import {SportDomainModel} from "../../sports/models/sport-domain-model";
import {FullAthleteIndividualStatDomainModel} from "../../full-athlete/models/full-athlete-stats/full-athlete.individual-stat.domain-model";

export class MemberDomainModel extends EntityDomainModel {
  apiModel: MemberApiModel;

  constructor(model: MemberApiModel, isNational: Boolean = false, sport: SportDomainModel){
    super(model);

    this.isNational = isNational;
    this.sport = sport;
  }

  get athleteId(): Number {
    return this.apiModel.athleteId;
  }

  get jerseyNumber(): Number {
    return this.apiModel.jerseyNumber;
  }

  get competitorId(): Number {
    return this.apiModel.competitorId;
  }

  get nameForUrl(): String {
    return this.apiModel.nameForURL;
  }

  get hasShotChart(): String {
    return this.apiModel.hasShotChart;
  }

  get suspensionRisk(): Boolean {
    return this.apiModel.suspensionRisk;
  }

  get suspensionStats(): Array<FullAthleteIndividualStatDomainModel> {
    return this.apiModel.suspensionStats ? this.apiModel.suspensionStats.sortAscending("order").map((stats: FullAthleteIndividualStatDomainModel) => new FullAthleteIndividualStatDomainModel(stats)) : null;  }
}
